import Header from "../components/Header";
import Footer from "../components/Footer";
import BottomTabBar from "../components/BottomTabBar";
import LegalShell from "../components/LegalShell";

export default function Privacy() {
  return (
    <div className="warm-bg min-h-screen">
      <Header />
      <LegalShell title="Privacy Policy" subtitle="Last updated: February 2026">
        <p>
          VibeCheck ("we", "us") is a couples game built to be fun, intimate, and
          private. This policy explains what we collect, why, and how we handle it.
        </p>

        <h2>1. What we collect</h2>
        <ul>
          <li>
            <b>Account data</b> (optional): name, email, hashed password — only if
            you sign up. You can play anonymously without an account.
          </li>
          <li>
            <b>Device ID</b>: an anonymous, randomly generated id stored in your
            browser. Used to track your free daily limit, intro-offer eligibility,
            and to attribute purchases to your device.
          </li>
          <li>
            <b>Room data</b>: the 6-character room code, current mode/pack, scores,
            and a short rolling history of the last few rounds. Rooms are temporary
            and tied to your gameplay session.
          </li>
          <li>
            <b>Voice notes &amp; videos</b>: when you record audio or video for a
            dare, the file is stored briefly so your partner can play it. Videos are
            <b> view-once</b> — they are deleted from our servers immediately after
            your partner watches them or skips/accepts the round.
          </li>
          <li>
            <b>Payments</b>: processed by Stripe. We never see or store your card
            details. We receive a transaction id, the SKU you bought, and a status
            (paid / pending / failed) to grant your unlock.
          </li>
          <li>
            <b>Analytics</b>: we use PostHog to understand which features people
            love, which ones break, and to spot abuse. We don't sell or share this
            data with advertisers.
          </li>
        </ul>

        <h2>2. What we don't do</h2>
        <ul>
          <li>We don't sell your data. Ever.</li>
          <li>We don't share your private answers with anyone.</li>
          <li>
            Shareable scorecards include <i>summary stats only</i> (rounds played,
            scores). We never put individual answers, voice notes, or videos onto a
            shareable card.
          </li>
          <li>We don't run third-party ad trackers.</li>
        </ul>

        <h2>3. Cookies</h2>
        <p>
          We use a single first-party storage entry to keep your device id,
          onboarding flag, and intro-offer state. No third-party advertising
          cookies.
        </p>

        <h2>4. Children</h2>
        <p>
          VibeCheck is intended for adults aged <b>18 and over</b>. Some packs
          contain mature content. If you're under 18, please don't use the app.
        </p>

        <h2>5. Your rights</h2>
        <p>
          You can request deletion of your account, room history, or recorded media
          at any time by emailing{" "}
          <a href="mailto:playvibcheck@gmail.com">playvibcheck@gmail.com</a>.
          We'll respond within 30 days.
        </p>

        <h2>6. Changes</h2>
        <p>
          If we update this policy, we'll change the "Last updated" date at the top
          and post a notice in-app for material changes.
        </p>

        <h2>7. Contact</h2>
        <p>
          Questions about privacy? Email{" "}
          <a href="mailto:playvibcheck@gmail.com">
            playvibcheck@gmail.com
          </a>
          .
        </p>
      </LegalShell>
      <Footer />
      <BottomTabBar />
    </div>
  );
}
